import { create } from 'zustand';

const initialState = {
  loading: false,
  clickedOnSave: false,
  showCheckbox: false,
  checkboxValue: false,
};

const useMappingUiStore = create((set) => ({
  ...initialState,
  setLoading: (v) => set({ loading: v }),
  setClickedOnSave: (v) => set({ clickedOnSave: v }),
  setShowCheckbox: (v) => set({ showCheckbox: v }),
  setCheckboxValue: (v) => set({ checkboxValue: v }),
  reset: () => set({ ...initialState }),
}));

export default useMappingUiStore;
